import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material'
import { Button, Typography } from '@mui/material'
import { isArray } from 'lodash'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { AlertBox } from 'components/Box'
import { BulletPointList } from './BulletPointList'
import { ONE_LINE_CHARACTERS_LIMIT } from './constants'
import { ErrorBoxProps } from './types'
import { prepareText } from './utils'

export const ErrorBox = ({ errorMessage, ...alertProps }: ErrorBoxProps): JSX.Element => {
  const { t } = useTranslation('features/globalSetup', {
    keyPrefix: 'googleAdManagerConnection',
  })
  const [expanded, setExpanded] = useState(false)

  const ShowMore: JSX.Element = (
    <Button
      data-cy='error-box-alert-button'
      endIcon={expanded ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
      onClick={() => setExpanded(prev => !prev)}
      sx={{
        '&, &:hover': {
          backgroundColor: 'inherit',
        },
        color: 'error.main',
        overflow: 'hidden',
        px: 0,
      }}
    >
      <Typography>{t(`errorBox.button.${expanded ? 'showLess' : 'showMore'}`)}</Typography>
    </Button>
  )

  return (
    <AlertBox
      {...alertProps}
      severity='error'
      title={t('errorBox.title')}
    >
      {isArray(errorMessage) ? (
        <BulletPointList
          expanded={expanded}
          items={errorMessage}
        />
      ) : (
        <Typography
          fontSize='inherit'
          sx={{ overflowWrap: 'break-word' }}
        >
          {prepareText({ expanded, text: errorMessage })}
        </Typography>
      )}

      {errorMessage.length > ONE_LINE_CHARACTERS_LIMIT && ShowMore}
    </AlertBox>
  )
}
